import { render, staticRenderFns } from "./LayerForm.vue?vue&type=template&id=16dd220e&scoped=true&"
import script from "./LayerForm.vue?vue&type=script&lang=js&"
export * from "./LayerForm.vue?vue&type=script&lang=js&"
import style0 from "./LayerForm.vue?vue&type=style&index=0&id=16dd220e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd220e",
  null
  
)

export default component.exports